import React from "react";
import clsx from "clsx";

const TasksNav = ({ tasksTypes, setTaskType, taskType }) => {
  return (
    <nav className="flex space-x-1 sm:space-x-4 border-b-2 sm font-semibold leading-tight">
      {tasksTypes.map(i => {
        const selected = taskType.value === i.value;
        return (
          <button
            className={`px-3 py-2 rounded-md ${selected ? "text-primary border-b-2 border-primary rounded-none" : "text-gray-500"} flex items-center gap-2`}
            onClick={() => setTaskType(i)}
          >
            <p className="m-0 p-0">{i.name}</p>
            {i.count > 0 && (
              <p
                className={clsx(
                  "border rounded-full flex items-center justify-center size-6 m-0 p-0",
                  {
                    "border-secondaryBorder bg-secondary": selected,
                  }
                )}
              >
                {i.count}
              </p>
            )}
          </button>
        );
      })}
    </nav>
  );
};
export default TasksNav;
